module.exports = __webpack_public_path__ + "static/media/default_entity.04f9d5fd.svg";